import { Link } from "easy-page-router/react";
import { useHead } from "../services/common";

export default function NotFound() {

    useHead({
        title: "Stránka nenalezena | T.J. Sokol Poniklá",
        description: "Stránka nenalezena | T.J. Sokol Poniklá"
    });

    return <section className="width-max">
        <h1>404 - stránka nenalezena</h1>
        <p>
            <Link href="/">Na hlavní stránku</Link>
        </p>
    </section>;
}
